import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import startsWith from 'lodash/startsWith';
import transformRelativePath from './transformRelativePath';

export default (excludeOptions, formValues, field) =>
  excludeOptions.reduce((exclude, option) => {
    if (startsWith(option, '&&')) {
      const value = get(formValues, option.slice(2));

      if (!isUndefined(value)) {
        exclude.push(value);
      }
    } else if (startsWith(option, '$$PARENT')) {
      const transformedField = transformRelativePath(field, option);
      const value = get(formValues, transformedField);

      if (!isUndefined(value)) {
        exclude.push(value);
      }
    } else {
      exclude.push(option);
    }

    return exclude;
  }, []);
